<template>
  <b-col sm="12" :lg="size" :offset-lg="offset">
    <div class="animated fadeIn">
      <b-card class="backClass">

        <!-- Header -->
        <div slot="header">
          <h5 style="display: inline;" class="card-title mb-0">{{ title }}</h5>
          <div class="card-header-actions">
            <b-button
              class="btn"
              variant="transparent p-1"
              attr="pdf"
              @click="downloadPDF()"
            >
              <b-button
                @click="toggleFullScreen"
                variant="transparent p-1"
              >
                <i style="color: #20a8d8;" class="icon-frame"></i>
              </b-button>
              <i class="fa fa-file-pdf-o" style="color: rgb(32, 168, 216);" aria-hidden="true"></i>
            </b-button>
          </div>
          <!-- Header END -->

        </div>

        <div class="chart-wrapper" >

          <!-- Loading -->
          <div style="height: 400px; padding-top: 150px" v-if="loadingData" class="loading" >
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <!-- Loading END -->

          <!-- Chart -->
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
          <!-- Chart END -->

        </div>

        <!-- Footer -->
        <div slot="footer">
          <b-button
            :disabled="!showAll"
            class="btn-outline"
            variant="outline-primary"
            left
            @click="showAll = false, fetchData()"
          >Top 10
          </b-button>

          <b-button
            :disabled="showAll"
            class="btn-outline float-right"
            variant="outline-primary"
            right
            @click="showAll = true, fetchData()"
          >All Data
          </b-button>
          <!-- Footer END -->

        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
    import {Chart} from "highcharts-vue";
    import Highcharts from "highcharts";
    import exporting from "highcharts/modules/exporting";
    import {chartOptionsFailureMixin} from "./addons/chartOptionsFailureMixin.js";
    import {chartFunctionsMixin} from "./addons/chartFunctionsMixin.js";

    exporting(Highcharts);

    export default {
        mixins: [chartOptionsFailureMixin, chartFunctionsMixin],
        components: {
            highcharts: Chart,
            Highcharts
        },
        props: ["size", "offset", "part", "type", "title"],
        data: function () {
            return {
                partNum: "",
                typeParam: "",
            };
        },
        methods: {
            fetchData() {
                this.loadingData = true;
                let params = {};
                params = {
                    fns_part: this.partNum
                };
                this.$http
                    .get("https://www.fibernode.com/api/viavi/products/getFailureDataBy" + this.typeParam + ".php", {params}).then(
                    res => {
                        if (!this.showAll) {
                            this.chartOptions.series[0].data = res.data.slice(0, 10);
                        } else {
                            this.chartOptions.series[0].data = res.data;
                        }
                        this.chartOptions.title.text = "Total units: " + res.data.totals;

                        this.loadingData = false;
                        setTimeout(() => {
                            this.changeHeight();
                        });
                    },
                    err => {
                        this.loadingData = false;
                        console.log(err);
                    }
                );
            },
        },
        mounted() {
            this.typeParam = this.type;
            this.partNum = this.part;
            this.fetchData();
        }
    };
</script>

<style>
  /* IE fix */
  #card-chart-01,
  #card-chart-02 {
    width: 100% !important;
  }

  .highcharts-exporting-group {
    display: none !important;
  }
</style>
